window.onload = () => {
  scrollSpy();
};

/**
 * Scrollspy with observer.
 * @return {Void}
 */
function scrollSpy() {
  const animations = document.getElementsByClassName('js-animation-parent');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      }
    },
    {
      rootMargin: '0% 0% 0% 0%',
    },
  );

  for (let i = 0; i < animations.length; i++) observer.observe(animations[i]);
}

let footer = document.querySelector('.footer');

/**
 * Show footer when in viewport on scroll
 * @param  {Void} )
 * @return {Void}
 */
window.addEventListener('scroll', function () {
  checkIfFooterIsVisible();
});

/**
 * Check if Footer Is Visible
 */
function checkIfFooterIsVisible() {
  if (
    document.documentElement.clientHeight -
      footer.getBoundingClientRect().top -
      100 >=
    0
  ) {
    footer.classList.add('is-visible');
  }
}

const modalModels = document.querySelector('.js-models');
const modalModelsWrappers = modalModels?.querySelectorAll('.modal__content');

/**
 * Add changing class to modal wrapper when modal swatch is clicked
 * @param  {Object}
 * @return {Void}
 */
if (modalModels) {
  modalModels.addEventListener('click', function (event) {
    const target = event.target;

    if (
      target.classList.contains('modal__swatch') &&
      document.documentElement.clientWidth > 990
    ) {
      target.closest('.modal__wrapper').classList.add('is-changing');

      setTimeout(function () {
        target.closest('.modal__wrapper').classList.remove('is-changing');
      }, 900);
    }
  });
}

/**
 * Calculate modal image height.
 * @return {Void}
 */
function calculateHeight() {
  if (!modalModels) return;

  let wrapperHeights = [];

  modalModelsWrappers.forEach(function (wrapper) {
    wrapperHeights.push(wrapper.clientHeight);
  });

  const minHeight = Math.min(...wrapperHeights);
  modalModels.style.setProperty('--max-height', minHeight + 'px');
}

/**
 * Call calucateHeight, checkIfFooterIsVisiblea and add class to Body
 * @param  {Void}
 * @return {Void}
 */
window.addEventListener('load', function () {
  document.body.classList.add('is-loaded');
  calculateHeight();
  checkIfFooterIsVisible();
});

window.addEventListener('resize', function () {
  calculateHeight();
});

window.addEventListener('shopify:section:load', (e) => {
  footer = document.querySelector('.footer');

  calculateHeight();
  checkIfFooterIsVisible();
  scrollSpy();
});
